// extracted by mini-css-extract-plugin
export default {"rowMargin":"legislation_articles_content-module__rowMargin--33tFI","articleLink":"legislation_articles_content-module__articleLink--39Bkl"};